module.exports = __webpack_public_path__ + "img/sj_logo.e10cffef.png";